import { downloadBlob, getBlob } from "../../common/actions/net";
import { messageType, pushSystemMessage } from "../../common/actions/systemMessage.js";

import { ContentTypes } from "../../common/net/httpClient";
import Logger from "../../common/util/Logger.js";
import { getApi } from "../../common/actions/net.js";
import moment from "moment";

export const SET_DOMINOS_ORDERS = "SET_DOMINOS_ORDERS";
export const SET_NO_OF_DOLLIES = "SET_NO_OF_DOLLIES";
export const CREATE_LABELS = "CREATE_LABELS";
export const SELECT_CUSTOMER = "SELECT_CUSTOMER";
export const LOADING = "LOADING";


/**
 * Gets dollys 
 * @returns {func}
 */
export function getOrdersForDoughProducts() {
    return async dispatch => {
        try {

            dispatch({
                type: LOADING,
                loading: true,
            });

            // Call webApi to get a list of dough orders
            const { payload } = await dispatch(
                getApi("Dominos/GetOrdersForDoughProductsQuery",
                    {
                    }));

            dispatch({
                type: SET_DOMINOS_ORDERS,
                payload: payload
            });
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Lasting av kunder mislyktes", messageType.error));
            Logger.error(error);
        } finally {
            dispatch({
                type: LOADING,
                loading: false,
            });
        }
        
    };
}

/**
 * Adds/removes a dolly to customer
 * @param {object} customer
 * @param {int} value
 * @returns {func}
 */
export function updateNoOfDollies(customer, value) {
    return async (dispatch) => {
        try {
            dispatch({
                type: SET_NO_OF_DOLLIES,
                salesOrderId: customer.salesOrderId,
                customer : {                    
                    ...customer,
                    noOfDollies: value
                }
            });
        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Oppdatering av antall bur feilet.", messageType.error));
            Logger.error(error);
        }
    };
}

/**
 * Marks a customer for printout
 * @param {object} customer
 * @param {object} change
 * @returns {func}
 */
export function selectCustomer(customer, change){
    return async (dispatch) => {
        try {
            await dispatch({
                type: SELECT_CUSTOMER,
                salesOrderId: customer.salesOrderId,
                customer : {                    
                    ...customer,
                    selected: change.selected
                }
            });
        } catch (error) {
            Logger.error(error);
        }
    };
}


/**
 * Creates a PDF with created dollies
 * @param {bool} treated
 * @returns {func}
 */
export function createAddressLabels(treated){
    return async (dispatch, getState) => {
        try {
            const state = getState();

            dispatch({
                type: CREATE_LABELS,
                creating: true,
            });

            const customers = treated ? state.dominosweb.customers.treatedCustomers : state.dominosweb.customers.untreatedCustomers;

            const customersToTreat = customers.filter(c => c.selected === true);

            // Convert to default layout
            const dollies = customersToTreat.map(c => {
                return {
                    "pickOrderId": c.salesOrderId,
                    "departmentStoreNo" : c.departmentStoreNo,
                    "noOfDollies" : c.noOfDollies,
                    "weightKg" : c.weightKg,
                    "volumeM3" : c.volumeM3,
                    "coldStore" : c.coldStore,
                };
            });

            const blob = await getBlob("Dominos/CreateAddressLabelsPdf", 
                {
                    loginId :  "Dominos",
                    dolliesForCustomers : dollies
                }
                ,  state.authentication.token, ContentTypes.JSON, ContentTypes.PDF, false);
            downloadBlob(blob, `transportetiketter_${moment().format("YYYYMMDDHHmmss")}.pdf`, ContentTypes.PDF);

            dispatch(getOrdersForDoughProducts());

        } catch (error) {
            dispatch( pushSystemMessage(error.message || "Fil ikke funnet", messageType.error) );
            Logger.error(error);
        } finally {
            dispatch({
                type: CREATE_LABELS,
                creating: false,
            });
        }
    };
}
